import { useQuery } from "@tanstack/react-query";
import { stripeApiService } from "../services/stripeApiService";
import { fromStripeConnectionDtoToStripeConnection, fromStripeFinanceSummaryDtoToStripeFinanceSummary } from "../types/stripeTypes";

export const stripeKeys = {
  all: ["stripe"] as const,
  detail: (businessId: string, userId: string) => [...stripeKeys.all, businessId, userId] as const,
  finances: (businessId: string, userId: string) => [...stripeKeys.detail(businessId, userId), "finances"] as const,
};
export const stripeConnectionOptions = (businessId: string, userId: string) => ({
  queryKey: stripeKeys.detail(businessId, userId),
  queryFn: async ({ signal }: { signal: AbortSignal }) => fromStripeConnectionDtoToStripeConnection(await stripeApiService.getByBusinessId(businessId, signal)),
  staleTime: 0,
  retry: false,
});
export const useStripeConnection = (businessId: string, userId: string) => useQuery(stripeConnectionOptions(businessId, userId));
export const useStripeFinances = (businessId: string | undefined, userId: string | undefined, enabled = true) => useQuery({
  queryKey: stripeKeys.finances(businessId ?? "", userId ?? ""),
  queryFn: async ({ signal }) => fromStripeFinanceSummaryDtoToStripeFinanceSummary(await stripeApiService.getFinances(businessId!, signal)),
  enabled: enabled && !!businessId && !!userId,
  staleTime: 60_000,
  retry: false,
});